import locale77304fa0 from '../../lang/de.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"de","numberFormats":{"de":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"en":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}}}},
  vueI18nLoader: false,
  locales: [{"code":"de","file":"de.js","iso":"de_DE","defaultCurrency":"EUR"},{"code":"en","file":"en.js","iso":"en_US","defaultCurrency":"EUR"}],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "/var/www/lang",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  seo: true,
  baseUrl: "http://0.0.0.0:8080",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  country: "US",
  normalizedLocales: [{"code":"de","file":"de.js","iso":"de_DE","defaultCurrency":"EUR"},{"code":"en","file":"en.js","iso":"en_US","defaultCurrency":"EUR"}],
  localeCodes: ["de","en"],
}

export const localeMessages = {
  'de.js': () => Promise.resolve(locale77304fa0),
  'en.js': () => import('../../lang/en.js' /* webpackChunkName: "lang-en.js" */),
}
